import Vue from 'vue'
import Vuex from 'vuex'
import orders from '@/store/modules/orders'
import routes from '@/store/modules/routes'
import users from '@/store/modules/users'
import modals from '@/store/modules/modals'
import auth from '@/store/modules/auth'
import permanentPoint from "./modules/permanentPoint";

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    orders,
    routes,
    users,
    modals,
    auth,
    permanentPoint
  }
})
